module.exports = __webpack_public_path__ + "static/media/IMG_0832.915d49d5.jpg";